import { IGetDocumentosByIdFornecedorUseCase } from "../../../presentation/useCases/read/get_documentos_by_id_fornecedor_use_case";
import { FornecedorDocumento } from "../../models/fornecedor_documento";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetDocumentosByIdFornecedorUseCase
 */

export class GetDocumentosByIdFornecedorUseCase implements IGetDocumentosByIdFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getDocumentosByIdFornecedor(
    idFornecedor: number | undefined,
  ): Promise<FornecedorDocumento[]> {
    if (idFornecedor === undefined) throw new Error('Falha ao obter id do fornecedor!');
    return await this.repository.getDocumentosByIdFornecedor(idFornecedor);
  }
}
